import { useState } from "react";
import { useLocation } from "react-router-dom";

import { Box, Divider, TextInput, Title } from "@mantine/core";
import { useDebouncedValue } from "@mantine/hooks";

import { CustomPagination } from "../components/pagination/CustomPagination.tsx";
import { TemplatesTable } from "../components/tables/TemplatesTable.tsx";
import { MAX_ELEMENTS_PER_PAGE } from "../constants/constants.ts";
import { useError } from "../hooks/useError.ts";
import { useTemplates } from "../hooks/useTemplates.ts";
import { ErrorPage } from "./ErrorPage.tsx";

export function TemplatesPage() {
  const location = useLocation();
  const previousPage = location.state?.pageNumber | 0;
  const [currentPage, setCurrentPage] = useState(previousPage);
  const [searchValue, setSearchValue] = useState("");
  const [debouncedSearch] = useDebouncedValue(searchValue, 300);
  const { templates, isLoading, isError, queryError } = useTemplates(currentPage, debouncedSearch);
  const { errorMessage } = useError(queryError);
  return isError ? (
    <ErrorPage
      code={errorMessage.code}
      title={errorMessage.title}
      description={errorMessage.description}
    />
  ) : (
    <>
      <Title>Templates</Title>
      <Divider size="sm" mb="lg" mt="lg" />
      <TextInput
        placeholder="Search by project name (e.g. TIMA)..."
        value={searchValue}
        onChange={(event) => {
          setSearchValue(event.currentTarget.value);
          setCurrentPage(0);
        }}
        mb="lg"
      />
      <Box mx="auto">
        <TemplatesTable
          templates={templates}
          isLoading={isLoading}
          currentPage={currentPage}
          maxElementsPerPage={MAX_ELEMENTS_PER_PAGE}
        />
        <CustomPagination
          totalPages={templates?.totalPages ?? 0}
          currentPage={currentPage}
          setCurrentPage={setCurrentPage}
        />
      </Box>
    </>
  );
}
